export default __webpack_public_path__ + "static/media/Google-Ads.4f0ca504.png";